import { useEffect, useState } from 'react';
import { Col, Form, Input, Row, Select } from 'antd';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import system from "../../../config/systematic";
import fetchApi from '../../../utils/api/fetchApi';
import antMessage from '../../../utils/extend/AntdNotification';
import getList from '../../universal/getList';
import WebRequireMentFormList from '../../generalComponents/WebRequireMentFormList';
import { showCustomNotification, useNotificationInstance } from '../../../utils/extend/AntdNotificationEx';

const { TextArea } = Input;

export default function CreateRequireMent(props: any) {

    const [form] = Form.useForm(); //form 
    const { closeModal, data } = props;

    /**需求类型数据 */
    const [expandCategoryData, setExpandCategoryData] = useState<any>([]);

    const [formList, setFormList] = useState<any>({ form })

    /**后端数据wmService */
    const wmService = system.wmService;

    const notificationApi = useNotificationInstance();

    useEffect(() => {

        const fetchData = async () => {
            form.setFieldsValue({ menuWarehouseId: data.menuWarehouseId });

            fetchApi.GET(wmService, {
                apiId: "expandCategory",
                apiExtend: 'showList',
            }).then(async res => {
                if (res.success) {
                    setExpandCategoryData(res.data);
                }
            })
        };
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    //把填写好的数据，先在前端整合再传到后台处理
    const organizeData = (data: any) => {
        let changeData: any = [];

        for (var i = 0; i < expandCategoryData.length; i++) {
            let expandTypes: any = [];

            let rules = JSON.parse(expandCategoryData[i].rules);
            let rulesType = rules?.type ? rules?.type : 'text';
            let expandCategoryId = expandCategoryData[i].id;
            let findData = 'expandTypeData_' + expandCategoryId;

            switch (typeof data[findData]) {
                case 'object':
                    for (var j = 0; j < data[findData].length; j++) {
                        expandTypes.push({
                            id: undefined,
                            expandTypeId: data[findData][j].expandTypeId,
                            amount: data[findData][j].amount,
                            productUnitId: data[findData][j].productUnitId,
                            memo: data[findData][j].memo,
                        })
                        if (j === data[findData].length - 1) {
                            changeData.push({
                                expandCategoryId,
                                rulesType,
                                expandTypes
                            })
                        }
                    }
                    break;
                case 'string':
                    changeData.push({
                        expandCategoryId,
                        rulesType,
                        expandDetail: data[findData]
                    })
                    break;
            }
        }
        return changeData;
    }

    const handleOk = (e: any) => {
        form.validateFields() //数据校验
            .then(async (values: any) => {
                let changeData = await organizeData(values);
                let nowData = { ...values, changeData };
                const editData = {
                    ...nowData
                }
                fetchApi.POST(wmService, {
                    apiId: "expandDetail",
                    apiExtend: "createRequireMent",
                    apiData: { ...editData }
                }).then(res => {
                    if (res.success) {
                        antMessage('success', '新建成功', 'success');
                        closeModal(true);
                    }
                }).catch(err => {
                    antMessage('error', '错误，无法保存', err.message + ' | status:' + err.errors.status);
                })
            })
            .catch((err: any) => {
                console.log(err);
                showCustomNotification(notificationApi!, {
                    type: 'warning',
                    message: "无法通过数据校验",
                    description: "请输入所需数据!"
                });
            });
    };

    const handleCancel = (e: any) => {
        closeModal();
    };

    return (
        <>
            <AntDraggableModal
                title={"新建需求"}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
                width={700}
            >
                <Form
                    form={form}
                    name="Edit"
                    onFinish={handleOk}
                >
                    <Row gutter={[16, 0]}>
                        <Col span={24}>
                            <Form.Item
                                label="智库菜品Id"
                                name="menuWarehouseId"
                            >
                                <Input disabled />
                            </Form.Item>
                        </Col>
                        {
                            expandCategoryData.length > 0 ? expandCategoryData.map((item: any, index: any) => {
                                let rules = JSON.parse(item.rules);
                                let rulesType = rules?.type ? rules?.type : 'text';
                                return (
                                    <>
                                        <Col span={0}>
                                            <Form.Item
                                                name={"expandCategoryId_" + item.id}
                                            >
                                                <Select
                                                    disabled
                                                    placeholder={item.expandCategoryName}
                                                    optionFilterProp="children"
                                                    filterOption={(input, option: any) =>
                                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                                    {getList.generalEx(expandCategoryData, {
                                                        itemName: 'expandCategoryName'
                                                    })}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}><Input style={{ color: 'yellow' }} value={item.expandCategoryName} disabled /></Col>
                                        <Col span={24}> </Col>
                                        <Col span={24}> </Col>
                                        <Col span={24}> </Col>
                                        <Col span={24}> </Col>
                                        {
                                            rulesType !== 'text' ?
                                                <Col span={24}>
                                                    <WebRequireMentFormList props={formList} formName={'expandTypeData_' + item.id} expandCategoryName={item.expandCategoryName} expandCategoryId={item.id} />
                                                </Col>
                                                :
                                                <Col span={24}>
                                                    <Form.Item
                                                        name={"expandTypeData_" + item.id}
                                                    >
                                                        <TextArea
                                                            placeholder={item.expandCategoryName}
                                                            autoSize={{ minRows: 2, maxRows: 5 }}
                                                            maxLength={250}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                        }
                                    </>
                                )
                            })
                                : null
                        }
                    </Row>
                </Form>
            </AntDraggableModal>
        </>
    );
};